import React, { useState, useEffect } from 'react';
import { IconButton, Badge, Box, TextField, Grid, Drawer } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from '@mui/icons-material';
import useCartStore from '../DataRepo/CartStore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CloseIcon from '@mui/icons-material/Close';
import TeleConsultationStore from '../DataRepo/TeleConsultationStore';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import calendaicon from '../Assets/images/Calender.png'
import clock from '../Assets/images/clock.png'
import offerimg from '../Assets/images/offer.png'
import appointmentconfetti from '../Assets/animations/appointmentconfetti.json'
import videocall from '../Assets/images/Video Call Orange Color.png'
import audiocall from '../Assets/images/Call Icon Orange Color.png'
import offerApplied from '../Assets/animations/offerapplied.json'
import Lottie from 'lottie-react';
import tickimg from '../Assets/images/Group 15940 (1).png'
import freetag from '../Assets/images/free-tag.png'
import { Button } from '@mui/material';
import { getUserDetails } from '../Auth/AuthUtil';
import { toast, Zoom } from 'react-toastify';
import axios from 'axios';
import { shopModel, teleConsultationModel } from '../Axios/AxiosConfig';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { profileModel } from '../Axios/AxiosConfig';
import uploadReportsimg from '../Assets/images/Frame 427319952.png'
import paymentsuccess from '../Assets/Raw/paymentsuccess_ding.mp3';
import success from '../Assets/animations/success lottie.json';
import Switch from '@mui/material/Switch';
import SubscriptionStore from '../DataRepo/SubscriptionStore';
import { Bolt } from 'lucide-react';
import { encryptBody } from '../Axios/Middleware';

function ConfirmSlot() {

    const { AppointmentDetails, setAppointmentDetails } = TeleConsultationStore();

    const { Subscriptiondetails, Subscriptiondetailsloading, getSubscriptiondetails, isSubscribed } = SubscriptionStore()

    const [paymentStatus, setPaymentStatus] = useState(null);

    const [checked, setChecked] = useState(false);

    const handleCheck = (event) => {
        setChecked(event.target.checked);

        if (event.target.checked) {

            setCouponDetails({
                couponName: "Free Consultation",
                couponType: "percentage",
                discount: 100,
            })
        }

        else {
            setCouponDetails(null)
        }
    };

    const { cartItems, updateQuantity, decreaseQuantity, isCartLoading, totalPrice, deliveryCharges, getCouponDetails, Coupons, CouponDetails, setCoupon, removeItem, getCart, clearCart, emptyCart, CouponErrorDetails, setCouponError, setCouponDetails } = useCartStore();

    const [hash, sethash] = useState('')

    const [msg, setmsg] = useState('na')

    const [coupon, setcoupon] = useState('')

    const [Transcation_id, setTranscation] = useState('')

    const userDetails = getUserDetails()

    const navigate = useNavigate();

    const [open, setOpen] = useState(false);

    const [open2, setOpen2] = useState(false);

    const [open3, setOpen3] = useState(false);

    const [open4, setOpen4] = useState(false);

    const [isprofileloading, setprofileloading] = useState(true)

    const [appointmentid, setappointmentid] = useState('')

    const [ProfileData, setProfileData] = useState([])

    const [errors, setErrors] = useState({
        email: '',
        phone: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;

        setProfileData((prevState) => ({
            ...prevState,
            [name]: value
        }));


        setErrors((prevState) => ({
            ...prevState,
            [name]: ''
        }));
    };

    const validateInputs = () => {
        let isValid = true;
        const newErrors = {};

        if (!ProfileData.email) {
            newErrors.email = 'Email is required';
            isValid = false;
        } else if (!/\S+@\S+\.\S+/.test(ProfileData.email)) {
            newErrors.email = 'Please enter a valid email';
            isValid = false;
        }

        if (!ProfileData.phone) {
            newErrors.phone = 'Phone number is required';
            isValid = false;
        } else if (!/^(?:\+91|91)?\d{10}$/.test(ProfileData.phone)) {
            newErrors.phone = 'Please enter a valid phone number';
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const ringtone = new Audio(paymentsuccess)

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleClickOpen2 = () => {
        setOpen2(true);
    };

    const handleClose2 = () => {
        setOpen2(false);
    };

    const price = parseInt(AppointmentDetails?.price);

    const handleClickOpen3 = () => {
        setOpen3(true);
    };

    const handleClose3 = () => {
        setOpen3(false);
    };

    const handleClickOpen4 = () => {
        setOpen4(true);
    };

    const handleClose4 = () => {
        setOpen4(false);
    };

    const getProfile = async (id) => {
        try {
            let res = await profileModel.get(`/Profile/${id}`)
            if (res.status === 200) {
                const profile = res?.data
                setProfileData(profile)
                setprofileloading(false)
            }
        }
        catch (err) {
            console.log(err?.response?.data)
        }
    }

    useEffect(() => {
        if (!AppointmentDetails) {
            navigate(-1)
        }
    }, [AppointmentDetails])

    useEffect(() => {
        getCouponDetails()
        getSubscriptiondetails()
        getProfile(userDetails?.UID)
    }, [])

    const handleCoupon = async (event) => {
        try {
            if (coupon) {
                await AvailCoupon(coupon, 'Tele', price, event)
            } else {
                setCouponError({ error: "Please enter coupon" });
            }
        }

        catch (error) {
            console.log("handleCoupon: Error applying coupon", error);
        }

    };

    const AvailCoupon = async (coupon, applicableTo, total, event) => {
        try {

            const res = await shopModel.post('/api/v1/avail-coupon', {

                coupon,
                applicableTo,
                total
            })

            if (res?.status === 200) {
                setCouponDetails(res.data)
                setCouponError(null)
                handleClickOpen4()
                setcoupon('')
                setTimeout(() => {
                    handleClose4()
                }, 3000)
                toggleDrawer('right', false)(event);
            }
        }

        catch (err) {
            setCouponError(err?.response?.data)
            console.log(err)
        }
    };

    const CreateAppointement = async (TranscationID) => {
        try {
            const payload = {
                appointment_status: "upcoming",
                consultation_status: "pending",
                txnid: TranscationID,
                appointment_date: AppointmentDetails.selectedDay,
                consultation_type: AppointmentDetails.selectedMode,
                appointment_time: AppointmentDetails.selectedTime,
                history_appointment_time: AppointmentDetails.selectedTime,
                history_appointment_date: AppointmentDetails.selectedDay,
                doctor_id: AppointmentDetails.DoctorDetails.PID,
                Paid: price - (price / 100) * discount,
                free_consultation: checked,
                doctor_uid: AppointmentDetails.DoctorDetails.UID,
                patient_id: userDetails?.UID,
                payment_status: "Paid",
                doctor_status: "pending",
            };

            const res = await teleConsultationModel.post('/api/v1/updateAndCreateAppointment', encryptBody(payload, { includeIv: false }));

            if (res?.status === 200) {
                const { Appointment_id } = res.data || {};

                if (!Appointment_id) {
                    console.error("❌ Appointment_id missing in response:", res.data);
                    return null;
                }

                setappointmentid(Appointment_id);
                setCouponDetails(null);

                return { status: res.status, data: { Appointment_id } };

            } else {
                console.error("❌ Failed to create appointment:", res);
                return null;
            }
        }
        catch (err) {
            toast.error(err?.response?.data, {
                position: 'top-center',
                limit: 1,
                transition: Zoom,
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'dark'
            });
            navigate(-1);
            console.log("🚨 CreateAppointment Error:", err?.response?.data || err.message);
            return null;
        }
    };

    const CompleteAppointement = async (Appointment_id) => {
        try {
            const res = await teleConsultationModel.post('/api/v1/updateAndCompleteAppointment', encryptBody({ Appointment_id }, { includeIv: false }));

            if (res.status === 200) {
                handleClickOpen2();
                await ringtone.play();
                setappointmentid('')
            }
        } catch (err) {

            toast.error(err?.response?.data, {
                position: 'top-center',
                limit: 1,
                transition: Zoom,
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'dark'
            });
            navigate(-1);
            console.log("CompleteAppointment Error:", err?.response?.data || err.message);
        }
    };

    const DeleteAppointment = async (Appointment_id) => {
        try {
            const res = await teleConsultationModel.post('/api/v1/deleteInitiatedAppointment', encryptBody({ Appointment_id }, { includeIv: false }));

            if (res?.status === 200) {
                setcoupon(null);
                setCouponDetails(null);
                setappointmentid('')
            }
        } catch (err) {
            console.log("DeleteAppointment Error:", err?.response?.data || err.message);
        }
    };

    const handleAppointment = async () => {
        try {
            const payload = {
                appointment_status: "upcoming",
                consultation_status: "pending",
                txnid: Transcation_id,
                appointment_date: AppointmentDetails.selectedDay,
                consultation_type: AppointmentDetails.selectedMode,
                appointment_time: AppointmentDetails.selectedTime,
                history_appointment_time: AppointmentDetails.selectedTime,
                history_appointment_date: AppointmentDetails.selectedDay,
                doctor_id: AppointmentDetails.DoctorDetails.PID,
                Paid: price - (price / 100) * discount,
                free_consultation: checked,
                doctor_uid: AppointmentDetails.DoctorDetails.UID,
                patient_id: userDetails?.UID,
                payment_status: "Paid",
                doctor_status: "pending",
            };

            const createRes = await teleConsultationModel.post('/api/v1/updateAndCreateAppointment', encryptBody(payload, { includeIv: false }));

            if (createRes.status !== 200) throw new Error("Failed to create appointment");

            const appointmentId = createRes?.data?.Appointment_id;

            setcoupon(null);
            setappointmentid(appointmentId);
            setCouponDetails(null);

            const completeRes = await teleConsultationModel.post('/api/v1/updateAndCompleteAppointment', encryptBody({ Appointment_id: appointmentId }, { includeIv: false }));

            if (completeRes.status !== 200) throw new Error("Failed to complete appointment");

            handleClickOpen2();
            await ringtone.play();
            // setappointmentid('')

        }

        catch (err) {

            const errorMessage =
                err?.response?.data?.message ||
                err?.response?.data ||
                err?.message ||
                "An unexpected error occurred";

            toast.error(errorMessage, {
                position: 'top-center',
                limit: 1,
                transition: Zoom,
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'dark'
            });

            console.error("handleAppointment Error:", errorMessage);

            navigate(-1);
        }

    };


    const invokePayPage = async (type, finalprice, Appointment_id) => {

        try {

            setPaymentStatus("processing");

            const amount = finalprice

            const encodedUdf1 = btoa(JSON.stringify({ Appointment_id }));

            const res = await shopModel.post("/api/v1/PhonePe/generate-token", encryptBody({
                amount,
                metaInfo: {
                    "udf1": encodedUdf1,
                    "udf2": '',
                },
            }));

            if (!res.data) {
                throw new Error("Token URL not received");
            }

            const callback = async (responseStatus) => {
                if (responseStatus === "USER_CANCEL") {
                    console.log("Transaction canceled by the user");
                    setPaymentStatus("failure");
                    await DeleteAppointment(Appointment_id);
                } else if (responseStatus === "CONCLUDED") {
                    console.log("Transaction concluded successfully");
                    setPaymentStatus("success");
                    const { hash, TranscationID } = res?.data;
                    sethash(hash);
                    setTranscation(TranscationID);
                    await CompleteAppointement(Appointment_id);
                } else {
                    console.warn("Unhandled responseStatus:", responseStatus);
                    setPaymentStatus("failure");
                    await DeleteAppointment(Appointment_id);
                }
            };

            if (
                typeof window !== "undefined" &&
                window.PhonePeCheckout &&
                typeof window.PhonePeCheckout.transact === "function"
            ) {
                window.PhonePeCheckout.transact({
                    tokenUrl: res.data.paymentUrl,
                    type,
                    callback,
                });
            } else {
                console.error("PhonePeCheckout or transact method not available");
                setPaymentStatus("failure");
            }

        } catch (error) {
            console.log("Error invoking PayPage:", error);
            setPaymentStatus("failure");
        }

    };

    const initiatePayment = async () => {
        if (ProfileData?.email !== '' && ProfileData?.phone !== '') {
            if (((price) - ((price / 100) * discount)) > 0) {
                try {
                    const txnid = Date.now().toString();

                    setTranscation(txnid);

                    const appointmentResponse = await CreateAppointement(txnid);

                    if (!appointmentResponse) {
                        console.log("❌ CreateAppointement returned undefined.");
                        return;
                    }

                    if (appointmentResponse?.status !== 200) {
                        console.log("❌ Appointment creation failed:", appointmentResponse);
                        return;
                    }

                    const firstname =
                        ProfileData?.firstname?.toString() ||
                        ProfileData?.lastname?.toString() ||
                        userDetails?.UID?.toString() ||
                        "User";

                    const amount = CouponDetails?.couponType === 'percentage'
                        ? (((price + deliveryCharges) - ((price / 100) * discount)).toFixed(2)).toString()
                        : (((price + deliveryCharges) - (CouponDetails?.cashRedeem || 0)).toFixed(2)).toString();

                    if (appointmentResponse?.status === 200) {
                        const { Appointment_id } = appointmentResponse?.data;
                        invokePayPage("IFRAME", amount, Appointment_id)

                    } else {
                        console.log("❌ Appointment request failed:", appointmentResponse);
                    }
                } catch (error) {
                    console.log("🚨 Appointment request failed:", error);
                }
            } else {
                handleAppointment();
            }
        } else {
            handleClickOpen3();
        }
    };

    const handleSaveProfile = async () => {
        if (validateInputs()) {
            try {
                let res = await profileModel.post(`/Profile`, { ...ProfileData });
                if (res.status === 200) {
                    handleClose3()
                    initiatePayment()
                }
            } catch (err) {
                console.log(err?.response?.data);
            }
        }
    };



    const discount = CouponDetails?.discount || 0;

    useEffect(() => {
        const getCoupons = async () => {
            await getCouponDetails('Tele', price);
        }

        getCoupons()
    }, [])

    const toggleDrawer = (anchor, open) => (event) => {

        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    const [state, setState] = useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });

    const list = (anchor) => (
        <Box sx={{
            width: (theme) => ({
                xs: '100%',
                sm: anchor === 'top' || anchor === 'bottom' ? 'auto' : 600,
                md: anchor === 'top' || anchor === 'bottom' ? 'auto' : 550,
            }),
        }}

            role="presentation"

        // onClick={toggleDrawer(anchor, false)}
        // onKeyDown={toggleDrawer(anchor, false)}

        >

            <div className='p-5'>
                <div className=' flex' style={{ justifySelf: "flex-end" }} >
                    <IconButton onClick={toggleDrawer(anchor, false)}>
                        <CloseIcon></CloseIcon>
                    </IconButton>
                </div>

                <div className="coupon-container mb-5 mt-5">

                    <input type="text" placeholder="Enter your coupon code" className="coupon-input" onChange={(e) => {
                        setcoupon(e.target.value)
                        setCouponError(null)
                    }} />

                    <button className="apply-button" onClick={(event) => {
                        handleCoupon(event);
                    }}>
                        Apply Coupon
                    </button>
                </div>

                {CouponErrorDetails &&
                    <p className='couponError'>{CouponErrorDetails?.error}</p>
                }


                <div className='flex flex-col gap-5'>
                    {
                        Coupons?.validCoupons && Coupons?.validCoupons?.filter((e) => e?.Public).map((e) => {
                            return <div className='flex'>

                                <div id="main" style={{ borderTopLeftRadius: "15px", borderBottomLeftRadius: "15px" }}>
                                    <div class="top right"></div>
                                    <div class="bottom right"></div>

                                    <div className='p-5 h-full coupon-discount-card' style={{ writingMode: "sideways-lr", textAlign: "center" }}>
                                        {e?.couponType === 'percentage' ?
                                            <p>{e?.discount}% Discount</p> :
                                            <p>Flat ₹{e?.cashRedeem} off</p>}
                                    </div>

                                </div>

                                <div id="main2" style={{ borderTopRightRadius: "15px", borderBottomRightRadius: "15px" }}>
                                    <div class="top left"></div>
                                    <div class="bottom left"></div>

                                    <div className='coupon-card-details flex flex-col h-full'>

                                        <div className='p-5'>
                                            <h2>Coupon Code: {e?.couponName?.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</h2>
                                            <div className='mt-5 cpninfotxt'>
                                                {
                                                    e?.couponType === 'percentage' ?
                                                        <p>Get {e?.discount}% discount for transaction above ₹{e.minValue}  </p> :
                                                        <p>Get Flat ₹{e.cashRedeem} off for transaction above ₹{e.minValue}</p>
                                                }
                                            </div>
                                        </div>

                                        <div className='p-3 mt-auto self-end w-full coupon-card-action'
                                            style={{ cursor: "pointer" }} onClick={(event) => {
                                                setCouponDetails(e)
                                                handleClickOpen4()
                                                setTimeout(() => {
                                                    handleClose4()
                                                }, 3000)
                                                toggleDrawer(anchor, false)(event)
                                            }}>
                                            <p className='text-right'>Apply</p>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        })
                    }

                    {
                        Coupons?.invalidCoupons && Coupons?.invalidCoupons?.filter((e) => e?.Public).map((e) => {
                            return <div className='flex'>

                                <div id="main" style={{ borderTopLeftRadius: "15px", borderBottomLeftRadius: "15px" }}>
                                    <div class="top right"></div>
                                    <div class="bottom right"></div>

                                    <div className='p-5 h-full coupon-discount-card' style={{ writingMode: "sideways-lr", textAlign: "center", backgroundColor: "#DFDFDE", color: "#A5A39D" }}>
                                        {e?.couponType === 'percentage' ?
                                            <p>{e?.discount}% Discount</p> :
                                            <p>Flat ₹{e?.cashRedeem} off</p>}
                                    </div>

                                </div>

                                <div id="main2" style={{ borderTopRightRadius: "15px", borderBottomRightRadius: "15px", backgroundColor: "#F4F4F4" }}>
                                    <div class="top left"></div>
                                    <div class="bottom left"></div>

                                    <div className='coupon-card-details flex flex-col h-full'>

                                        <div className='p-5'>
                                            <h2 style={{ color: "#BBBBBB" }}>Coupon Code: {e?.couponName?.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</h2>

                                            <div className='mt-5 cpninfotxt' style={{ color: "#C7C7C7" }}>
                                                <p>Add products worth ₹{e?.minValue} to avail this deal! - Your health is the best investment</p>
                                            </div>

                                        </div>

                                        <div className='p-3 mt-auto self-end w-full coupon-card-action'>
                                            <p className='text-right' style={{ color: "#A5A39D" }}>Apply</p>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        })
                    }
                </div>

            </div>


        </Box>

    );

    return <div className='All-products-section-main'>
        <nav className='flex flex-row p-2 items-center justify-between'>
            <div className='flex flex-row items-center'>
                <IconButton onClick={() => navigate(-1)}>
                    <ChevronLeft />
                </IconButton>
                <p className='mb-0'>Confirm Appointment</p>
            </div>
        </nav>

        <div className='Appointment-confirm-page'>

            <div className='Appointment-confirm-page-doctor-details'>
                <div>
                    <img src={AppointmentDetails?.DoctorDetails?.img}></img>
                    <div className='Appointment-confirm-page-doctor-info-details'>
                        <div>
                            <p>{AppointmentDetails?.DoctorDetails?.name}
                                &nbsp;
                                <span>{AppointmentDetails?.DoctorDetails?.course_details}</span>
                            </p>
                            <p>{AppointmentDetails?.DoctorDetails?.speciality}</p>
                        </div>

                        <div>
                            <p>Appointment details</p>
                            <div className='Appointment-selected-info'>
                                <div>

                                    <div className='icons'>
                                        <img src={calendaicon} ></img>
                                    </div>

                                    <div>
                                        <p>{AppointmentDetails?.selectedDay}</p>
                                    </div>

                                </div>

                                <div>

                                    <div className='icons'>
                                        <img src={clock} ></img>
                                    </div>

                                    <div >
                                        <p>{AppointmentDetails?.selectedTime}</p>
                                    </div>

                                </div>

                                <div>
                                    <div className='icons'>
                                        <img src={AppointmentDetails?.selectedMode === 'Video' ? videocall : audiocall}></img>
                                    </div>
                                    <div>
                                        <p>{AppointmentDetails?.selectedMode}</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='Appointment-confirm-page-info mb-10'>
                {/* <div>
                    <p>Any Message for Doctor</p>
                    <div className='mt-3'>
                        <TextField
                            id="outlined-multiline-static"
                            label="Enter your message"
                            multiline
                            fullWidth
                            rows={4}
                            onChange={(e) => {
                                setmsg(e.target.value)
                            }}
                        />
                    </div>
                </div> */}

                {isSubscribed && Subscriptiondetails?.teleconsultationlimit > 0 &&
                    <div className='mt-5'>
                        <div style={{
                            backgroundColor: checked ? "#7FD67F" : "#D2D2D2",
                            borderRadius: "10px"
                        }}>
                            <div className='flex justify-between p-5'
                                style={{
                                    backgroundColor: checked ? "#DBF9DB" : "#EFEFE7",
                                    borderRadius: "10px"
                                }}
                            >

                                <div className='flex items-center gap-5 freetag'>

                                    <img src={freetag} />

                                    <div>
                                        <p>Enable your free consultation </p>
                                        <p>{Subscriptiondetails?.teleconsultationlimit - 1 + 1} Free Tele-Consultation left</p>
                                    </div>

                                </div>

                                <div>
                                    <Switch
                                        checked={checked}
                                        size='large'
                                        sx={{

                                            "& .MuiSwitch-switchBase.Mui-checked": {
                                                color: "#7FD67F",
                                            },
                                            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                                                backgroundColor: "#7FD67F",
                                            },
                                            "& .MuiSwitch-track": {
                                                backgroundColor: "#bdbdbd",
                                            },
                                        }}
                                        onChange={handleCheck}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                    />
                                </div>

                            </div>

                            <div className='p-5 text-center freetaginfo'>
                                <p>As part of your subscription, you are entitled to <span>
                                    3 free tele consultations</span>
                                </p>
                            </div>
                        </div>
                    </div>
                }

                {/* {!CouponDetails &&
                    <div className="coupon-container mt-5">
                        <input type="text" placeholder="Enter your coupon code" className="coupon-input" onChange={(e) => {
                            setcoupon(e.target.value)
                            setCouponError('')
                        }} />
                        <button className="apply-button" onClick={handleCoupon} >Apply</button>
                    </div>
                } */}

                {!CouponDetails &&
                    <div className='flex items-center justify-between couponsandofferscontainer mt-5' style={{ cursor: "pointer" }}
                        onClick={toggleDrawer("right", true)}>
                        <p>View Coupons & Offers</p>
                        <IconButton><ChevronRightIcon /></IconButton>
                    </div>
                }

                {CouponDetails &&
                    <div className="CouponAppliedContainer mt-5">
                        <div className="lottie-background">
                            <Lottie animationData={offerApplied} />
                        </div>
                        <div className="content">
                            <img src={offerimg} alt="Offer" />
                            <div>

                                <p>{CouponDetails?.couponName?.toUpperCase()} Applied</p>

                                {
                                    CouponDetails?.couponType === 'percentage' ?
                                        <p>You have saved ₹{((price / 100) * discount).toFixed(2)} by applying a {discount}% discount for this order</p> :
                                        <p>You have saved ₹{CouponDetails?.cashRedeem} by applying a coupon for this order</p>
                                }

                            </div>
                        </div>

                        <IconButton style={{ alignSelf: "flex-start", justifySelf: "flex-end", marginLeft: 'auto' }} onClick={() => {
                            setCouponDetails(null)
                        }}>
                            <HighlightOffIcon />
                        </IconButton>
                    </div>
                }

                {/* {
                    CouponErrorDetails != '' &&
                    <p className='CouponErrorDetails'>{CouponErrorDetails?.error}</p>
                } */}


                <div className='Cart-total-container mt-5 mb-5'>
                    <div>
                        <p>Consultation fees</p>
                    </div>
                    <div>
                        <div>
                            <p>Sub Total</p>
                            <p>{`₹ ${price}`}</p>
                        </div>


                        {
                            CouponDetails &&
                            <div>
                                <p>Coupon Discount</p>
                                <p>- ₹{CouponDetails?.couponType === 'percentage' ?
                                    ((price / 100) * discount).toFixed(2) : (CouponDetails?.cashRedeem || 0)}</p>
                            </div>
                        }
                    </div>
                    <div>
                        <p>Total : <span>₹ {CouponDetails?.couponType === 'percentage' ?
                            ((price) - ((price / 100) * discount)).toFixed(2) :
                            ((price) - (CouponDetails?.cashRedeem || 0))}</span></p>
                    </div>
                </div>

            </div>

        </div>

        <div style={{ padding: "1rem", position: "fixed", bottom: 0, width: "100%", display: "flex", alignItems: "center", justifyContent: "flex-end", backgroundColor: "#fdfdfd" }}>

            <div>
                <Button
                    style={{
                        width: '100%',
                        textTransform: 'none',
                        backgroundColor: '#DA6E0B',
                        color: '#FDFDFD',
                        border: '1px solid #DA6E0B',
                        boxSizing: 'border-box',
                        paddingRight: "3rem",
                        paddingLeft: "3rem",
                        borderRadius: "5px",
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: 500,
                        padding: "10px"
                    }}
                    onClick={() => initiatePayment()}
                >
                    {((price) - ((price / 100) * discount)) > 0 ? 'Pay and Confirm' : 'Proceed to Confirm'}
                </Button>
            </div>

        </div>

        <Dialog
            open={open3}
            onClose={handleClose3}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {"Contact details"}
            </DialogTitle>

            <DialogContent>

                <div className='mt-5'>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Email"
                                variant="outlined"
                                fullWidth
                                name="email"
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#DA6E0B',
                                        },
                                    },
                                }}
                                value={ProfileData.email}
                                onChange={handleChange}
                                error={!!errors.email}
                                helperText={errors.email}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Phone"
                                variant="outlined"
                                fullWidth
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#DA6E0B',
                                        },
                                    },
                                }}
                                name="phone"
                                value={ProfileData.phone}
                                onChange={handleChange}
                                error={!!errors.phone}
                                helperText={errors.phone}
                            />
                        </Grid>
                    </Grid>
                </div>

                <p className='mt-2'
                    style={{
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: 400,
                        fontSize: "12px"
                    }}
                >

                    Please fill in your email and phone number before continuing with the appointment.</p>

            </DialogContent>

            <DialogActions>
                <Button
                    style={{
                        textTransform: 'none',
                        backgroundColor: '#DA6E0B',
                        color: '#FDFDFD',
                        border: '1px solid #DA6E0B',
                        boxSizing: 'border-box',
                        borderRadius: "5px",
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: 500,
                        padding: "10px"
                    }}

                    onClick={handleSaveProfile} autoFocus>
                    Save
                </Button>
            </DialogActions>

        </Dialog>

        <Dialog
            open={open2}
            onClose={handleClose2}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent>
                <div className="Lottie-background">
                    <Lottie animationData={appointmentconfetti}></Lottie>
                </div>
                <div className='flex flex-col items-center gap-5'>

                    <img src={tickimg} style={{ width: '5rem' }}>
                    </img>

                    <div className='uploadimgreportinfo text-center'>
                        <p >Your appointment with {AppointmentDetails?.DoctorDetails?.name} has been successfully booked</p>
                    </div>

                    <div className='text-center p-5 selectedDatetime'>
                        <p>On {AppointmentDetails?.selectedDay.split('-').reverse().join('-')}</p>
                        <p className='mt-1'>{AppointmentDetails?.selectedTime}</p>
                    </div>

                    <div className='flex p-3 gap-5 flex-col md:flex-row items-center' style={{ border: "1px dashed #75623F" }}>
                        <div className='uploadimgreport'>
                            <img src={uploadReportsimg} />
                        </div>
                        <div className='uploadimgreportinfo'>
                            <p>Upload Reports</p>
                            <p>Please upload relevant medical reports, lab tests, or treatment details for the doctor’s review</p>
                            <div>
                                <div className='flex flex-col md:flex-row-reverse gap-5 justify-content-around align-items-center mt-2'>


                                    <div style={{ width: "100%" }}>
                                        <Button
                                            style={{
                                                width: '100%',
                                                textTransform: 'none',
                                                borderRadius: '0',
                                                backgroundColor: '#DA6E0B',
                                                color: 'white',
                                                border: 'none',
                                                boxSizing: 'border-box',
                                                borderRadius: '5px',
                                                fontFamily: "'Poppins', sans-serif",
                                                fontWeight: 500,
                                                padding: '10px'
                                            }}

                                            onClick={() => {
                                                navigate('/Reports?type=tele', { state: { appointmentid } })

                                            }}

                                        >
                                            Add Reports
                                        </Button>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>

                    <div>
                        <p style={{
                            fontFamily: "'Poppins', sans-serif",
                            fontWeight: 400,
                        }}>
                            Don’t have any reports? &nbsp;
                            <span
                                onClick={(e) => {
                                    navigate('/prakritiintro')
                                }}
                                style={{
                                    cursor: "pointer",
                                    borderBottom: '1px solid #DA6E0B ',
                                    color: '#DA6E0B',
                                }}>
                                Skip to Ayurveda assessment
                            </span>
                        </p>
                    </div>




                </div>
            </DialogContent>
        </Dialog>

        <Dialog
            open={open4}
            onClose={handleClose4}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="sm"
            fullWidth
            PaperProps={{
                style: { borderRadius: '10px', overflow: 'hidden' }
            }}
        >
            <DialogContent className='cpndialogbg'>
                <div className="Lottie-background">
                    <Lottie animationData={appointmentconfetti}></Lottie>
                </div>
                {/* <div className='flex justify-end'>
                    <IconButton onClick={handleClose4}>
                        <CloseIcon></CloseIcon>
                    </IconButton>
                </div> */}

                <div className='flex flex-col items-center gap-3 justify-center'>

                    <img src={tickimg} style={{ width: '5rem' }}>
                    </img>

                    <div className='uploadimgreportinfo text-center'>
                        <p >Congrats!</p>
                    </div>

                    <div className='flex p-5 cpnapplied'>
                        <p>{CouponDetails?.couponName?.toUpperCase()} Coupon is Applied</p>
                    </div>

                    <div className='cpnsaved'>
                        <p>You have saved ₹{CouponDetails?.couponType === 'percentage' ?
                            ((price / 100) * discount).toFixed(2) : (CouponDetails?.cashRedeem || 0)}</p>
                    </div>

                </div>
            </DialogContent>

        </Dialog>

        <Drawer
            anchor={'right'}
            open={state['right']}
            onClose={toggleDrawer('right', false)}
        >
            {list('right')}
        </Drawer>

    </div>
}

export default ConfirmSlot
